module.exports = __webpack_public_path__ + "img/bars-filter.16282815.svg";